import Info from "component/details/Info";
import InfoAction from "component/details/InfoAction";
import BannerImage from "component/details/BannerImage";
import GameButtons from "component/details/GameButtons";
import RoundDetails from "component/details/RoundDetails";

export { Info };
export { InfoAction };
export { BannerImage };
export { GameButtons };
export { RoundDetails };

export default Object.assign({
  Info,
  InfoAction,
  BannerImage,
  GameButtons,
  RoundDetails,
});
